import type {
  TYPE_DESIRED_COLOR_OPTIONS,
  TYPE_MATERIAL_OPTIONS,
} from '../../constants/colors-and-materials';
import type { TYPE_ROOM_MODE_OPTIONS } from '../../constants/room-mode';
import type { TYPE_DESIRED_STYLE_OPTIONS } from '../../constants/room-style';
import type { TYPE_ROOM_TYPE_OPTIONS } from '../../constants/room-type';
import { AdditionalInfo } from './additional-info';
import { DesiredColorSettings } from './desired-color-settings';
import { DesiredStyleSettings } from './desired-style-settings';
import { GoodWeatherOptionsSettings } from './good-weather-options-settings';
import { MaterialSettings } from './materials-settings';
import { RoomModeSettings } from './room-mode-settings';
import { RoomTypeSettings } from './room-type-settings';
import { WatermarkSection } from './watermark';

export type StyleSettings = {
  roomMode?: TYPE_ROOM_MODE_OPTIONS;
  roomType?: TYPE_ROOM_TYPE_OPTIONS;
  desiredStyle?: TYPE_DESIRED_STYLE_OPTIONS;
  desiredColor?: TYPE_DESIRED_COLOR_OPTIONS[];
  materials?: TYPE_MATERIAL_OPTIONS[];
};

export const StyleSettings = () => {
  return (
    <div className="flex flex-col gap-2">
      <RoomModeSettings />
      <GoodWeatherOptionsSettings />
      <RoomTypeSettings />
      <DesiredStyleSettings />
      <DesiredColorSettings />
      <MaterialSettings />
      <AdditionalInfo />
      <WatermarkSection />
    </div>
  );
};
